import listeners from '../listeners';

export default {
  getHoveredComponent(e) {
    if (e.target.tagName === 'HTML') return null;
    const componentElement = e.target.closest('[data-gp-component-id]');
    if (componentElement) {
      return componentElement.getAttribute('data-gp-component-id');
    }
    return null;
  },
  outOfFrameMouseMove(targetDocument, targetWindow, e) {
    if (!e.target.ownerDocument) {
      return;
    }
    const evt = targetDocument.createEvent('CustomEvent');
    evt.initEvent('mousemove', true, true);
    evt.clientX = e.detail.clientX;
    evt.clientY = e.detail.clientY;
    targetWindow.dispatchEvent(evt);
  },
  outOfFrameMouseUp(targetDocument, targetWindow, e) {
    if (!e.target.ownerDocument) {
      return;
    }
    const evt = targetDocument.createEvent('MouseEvents');
    evt.initEvent('mouseup', true, true);
    targetWindow.dispatchEvent(evt);
  },
  registerOutOfFrameListeners(targetDocument, targetWindow) {
    listeners.register(
      document,
      'mousemove',
      e => this.outOfFrameMouseMove(targetDocument, targetWindow, e),
      'canvas'
    );
    listeners.register(
      document,
      'mouseup',
      (e) => this.outOfFrameMouseUp(targetDocument, targetWindow, e),
      'canvas'
    );
  }
};